import { useState, useContext, useRef, useEffect, useCallback } from 'react';

import '../../FinancialBuilder/DashboardOverview/DashboardOverview.css';
import { DollarOutlined, TableOutlined, CalculatorFilled } from '@ant-design/icons';
import { CriticalFinancePageContext } from '../CriticalFiancePage.jsx'
import { ShowAndHide } from '../../helperFunctions.jsx';

import { genericPOSTDatabaseCall, SidebarButton, RenderOneTable } from '../../helperFunctions.jsx'
import { EntityDetails } from '../EntitiesPage/EntitiesPage.jsx';

import InvestmentEquityModal from '../Misc/InvestmentEquityModal.jsx';
import CapTableSettingsModal from '../Misc/CapTableSettingsModal.jsx';


// <SidebarButton icon={<SettingFilled className='sidebar-icon' />} itemInModal={<SettingsPage />} />

function DashboardSideBar({ onClickUpdateCalc }) {
    const sidebarRef = useRef();

    document.addEventListener('scroll', () => {
        if (sidebarRef.current) {
            sidebarRef.current.style.top = `${window.scrollY + 50}px`;
        }
    });

    return (
        <div className="fb-dashboard-sidebar" ref={sidebarRef}>
            <SidebarButton name={"Financials"} icon={<DollarOutlined className='sidebar-icon' />} itemInModal={<InvestmentEquityModal />} />
            <SidebarButton name={"Data Tables"} icon={<TableOutlined className='sidebar-icon' />} itemInModal={<CapTableSettingsModal />} />
            <SidebarButton onClickUpdateCalc={onClickUpdateCalc} isModal={false} name={"Calculate"} icon={<CalculatorFilled className='sidebar-icon' />} />
        </div>
    );
}

function CapTable({ data }) {
    return (
        <div>
            <table className="entity-table">
                <thead>
                    <tr>
                        <th>Shareholders</th>
                        <th>Share %</th>
                        <th>USD (PV)</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((item, index) => (
                        <tr key={index}>
                            <td>{item.name}</td>
                            <td>{item.sharePercentage}</td>
                            <td>{item.presentValue}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

function Dashboard() {
    const { setPageNum, entitySelected, messageApi } = useContext(CriticalFinancePageContext);
    const [dataLoading, setDataLoading] = useState(true);
    const [calculationData, setCalculationData] = useState({
        investment_data: [],
        share_price_data: [],
        valuation_at_ipo: [],
        cap_table_data: []
    });

    const getUpdatedCalculations = useCallback(async () => {
        messageApi.loading('Fetching updated calculations...', 0);
        try {
            const response = await genericPOSTDatabaseCall('/api/cfi/getCalculationData', { entity: entitySelected }, "calculation data");
            console.log('Updated calculation data:', response);
            setCalculationData(response.data);
            messageApi.destroy();
            messageApi.success('Calculations updated successfully');
        } catch (error) {
            console.error('Error fetching calculation data:', error);
            messageApi.destroy();
            messageApi.error('Failed to fetch updated calculations');
        }
        setDataLoading(false); // Only set to false after first load
    }, [entitySelected, messageApi])

    useEffect(() => {
        getUpdatedCalculations();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="fb-dashboard-overview financial-builder-container entity-industry-container">
            <h2>Summary Page</h2>
            <ShowAndHide title={"Entity Info"}>
                <EntityDetails entity={entitySelected} editable={false} />
            </ShowAndHide>
            {!dataLoading &&
                <>
                    <ShowAndHide defaultOpen title="CFI - Valuations, Investments, Pricing and Equity" className="fb-dashboard-overview-content">
                        <div className='flex-row flex-space-around'>
                            <RenderOneTable data={calculationData.form_projections} name={"From Projections"} />
                            <RenderOneTable data={calculationData.investment_data} name={"Investment Consideration"} />
                            <RenderOneTable data={calculationData.share_price_data} name={"Price your Share"} />
                        </div>
                    </ShowAndHide>
                    <ShowAndHide defaultOpen title="Valuations & Cap Tables (@IPO)" className="fb-dashboard-overview-content">
                        <div className='flex-row flex-space-around'>
                            <RenderOneTable data={calculationData.valuation_at_ipo} name={"Valuation at IPO"} />
                            <CapTable data={calculationData.cap_table_data} />
                        </div>
                    </ShowAndHide>
                </>
            }
            <div className="navigation-button-container">
                <button type="button" onClick={() => setPageNum(2)} className="next-button">Back</button>
            </div>
            <DashboardSideBar onClickUpdateCalc={getUpdatedCalculations} />
        </div>
    )
}

export default Dashboard;